export default __webpack_public_path__ + "static/media/1995.008a2f39.png";